import { render, staticRenderFns } from "./NewsCategory.vue?vue&type=template&id=45aaf528&"
import script from "./NewsCategory.vue?vue&type=script&lang=js&"
export * from "./NewsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports